<template>
<v-container>

  <esign-video-resume2
    :token="$store.getters.esignToken"
    :end-point="endPoint"
    :operation-uuid="$store.getters.operationUuid"
    :video-uuid="$store.getters.videoUuid"
    @notify="notify"
    @success="success"
    @error="error"
  ></esign-video-resume2>

</v-container>
</template>

<script>
import EsignVideoResume2 from "@/components/signature/VideoIdentificationResume2";
export default {
  name: "resumeIdentification",
  components: {
    EsignVideoResume2
  },
  // mounted() {
  //   // Google Analytics
  //   this.$ga.page(this.$router);
  // },
  data() {
    return {
      endPoint: process.env.VUE_APP_BASEURL,
             currentItem: "tab-Web",
    items3: ["Biometry", "Front", "Back", "Ocr"] ,   
 
    };
  },
  methods: {}
};
</script>

<style scoped>
</style>
